<template>
  <div>
    <div class="nav" :class="{ bgwhite: whiteHeader }">
      <!-- <div class="trip-logo flex-center">
        <img src="../assets/images/home/trip-logo.png" alt="">
      </div> -->
      <div class="main_box">
        <img @click="handleToWebsite" v-if="whiteHeader" class="logo-red" src="../assets/images/home/logoRed.png" alt="">
        <img @click="handleToWebsite" v-else class="logo-red" src="../assets/images/home/trip-logo.png" alt="">
        <div class="el-menu-trip">
          <span :class="{ active: selectPage === '1', 'c-w': !whiteHeader  }" @click="handleSelect('1')">{{moduleType === 'TRIP' ? '票务预订' : (moduleType === 'HOTEL' || moduleType === 'PACKAGES') ? '酒店预订' : '首页'}}</span>
          <span :class="{ active: selectPage === '2', 'c-w': !whiteHeader }" @click="handleSelect('2')">个人中心</span>
          <span class="cart" v-if="moduleType === 'RETAIL'" @click="handleSelect('3')">
            <img src="../assets/images/home/whitecar.png" alt="" />
            <span :class="{ active: selectPage === '3', 'c-w': !whiteHeader }">购物车({{cartNum}})</span>
          </span>
        </div>
        <div class="btns">
          <div class="white-btn" @click="handleToWebsite">官网</div>
          <div class="red-btn ml12" v-if="!LoginBtnShow" @click="handleLogin">登录</div>
        </div>
         <div class="home_btn" v-if="LoginBtnShow">
          <div style="position: relative;padding-left: 58px;">
          <img class="player_icon" :src="userInfo.avatarUrl || require('@/assets/images/head.png')" />
            <div class="name-box" :class="{ 'name-box1': whiteHeader }">
                <span class="hidden-mobile">{{userInfo.phone || mobile}} <i class="el-icon-arrow-down"></i></span>
                <div class="hidden-btn">
                  <span @click="toRegist(3)"><img src="../assets/images/home/edit.png"/>修改密码</span>
                  <span @click="handleLogOut"><img src="../assets/images/home/out.png"/>退出</span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { loadList } from '@/api/retail/cart'
export default {
  data () {
    return {
      thirdInfo: {
        headImgUrl: '',
        nickName: '',
        mobile: null
      },
      selectPage: '1',
      homeUrl: '/',
      moduleType: 'TRIP',
      whiteHeader: true
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo || {},
      cartNum: state => state.cartNum || 0
    })
  },
  props: ['homeBtnHide', 'LoginBtnShow', 'banner', 'welcome', 'logo', 'pageIndex'],
  created () {
    this.thirdInfo = sessionStorage.getItem('thirdInfo') ? JSON.parse(sessionStorage.getItem('thirdInfo')) : {}
    if (this.LoginBtnShow) {
      this.mobile = sessionStorage.getItem('mobile')
    }
    // 页面刷新时记录首页地址及模块类型
    this.setHomeUrl(this.$route)
  },
  watch: {
    'LoginBtnShow': function () {
      if (this.LoginBtnShow) {
        this.mobile = sessionStorage.getItem('mobile')
        this.loadCartNum()
      }
    },
    'pageIndex': function () {
      sessionStorage.setItem('pageIndex', this.pageIndex)
      this.selectPage = this.pageIndex
    },
    // 直接更改地址栏时记录首页地址及模块类型
    $route (to) {
      this.setHomeUrl(to)
    }
  },
  methods: {
    handleToWebsite () {
      window.location.href = 'https://www.xiqiaoshantour.com'
    },
    // 加载购物车
    loadCartNum () {
      loadList(this.userInfo.merchId).then(res => {
        if (res.code === 0) {
          if (res.data && res.data.cartItems) {
            this.$store.dispatch('setcartNum', res.data.cartItems.length)
          }
        }
      })
    },
    setHomeUrl (route) {
      const nowPath = route.path
      if (nowPath === '/' || nowPath === '/hotelList' || nowPath === '/foodList' || nowPath === '/retailList' || nowPath === '/packageTicketList') {
        this.whiteHeader = true
      } else {
        this.whiteHeader = false
      }
      // 设置selectPage默认值1
      if (nowPath === '/' || nowPath === '/hotelList' || nowPath === '/foodList' || nowPath === '/retailList' || nowPath === '/packageTicketList') {
        this.selectPage = '1'
      } else if (nowPath === '/tripOrderList' || nowPath === '/retailOrderList' || nowPath === '/orderEvaluate' || nowPath === '/orderListNew' || nowPath === '/orderDetailNew' || nowPath === '/personalInfo' || nowPath === '/personalEdit' || nowPath === '/receiveAddress') {
        this.selectPage = '2'
      } else if (nowPath === '/cart') {
        this.selectPage = '3'
      } else {
        this.selectPage = null
      }
      // 记录首页地址及模块类型
      let homeUrl = '/'
      let moduleType = 'TRIP'
      if (nowPath.indexOf('hote') !== -1) {
        homeUrl = '/hotelList'
        moduleType = 'HOTEL'
      } else if (nowPath.indexOf('food') !== -1) {
        homeUrl = '/foodList'
        moduleType = 'FOOD'
      } else if (nowPath.indexOf('retail') !== -1 || nowPath === '/cart' || nowPath.indexOf('afterSales') !== -1) {
        homeUrl = '/retailList'
        moduleType = 'RETAIL'
      } else if (nowPath.indexOf('packageTicket') !== -1 || nowPath.indexOf('PackageTicket') !== -1) {
        homeUrl = '/packageTicketList'
        moduleType = 'PACKAGES'
      } else if (nowPath === '/orderListNew' || nowPath === '/orderEvaluate' || nowPath === '/orderDetailNew' || nowPath === '/personalInfo' || nowPath === '/personalEdit' || nowPath === '/paySucceed' || nowPath === '/payFailed' || nowPath === '/payOrderNew' || nowPath === '/receiveAddress') {
        moduleType = route.query.moduleType || 'TRIP'
        if (moduleType === 'HOTEL') {
          homeUrl = '/hotelList'
        } else if (moduleType === 'FOOD') {
          homeUrl = '/foodList'
        } else if (moduleType === 'RETAIL') {
          homeUrl = '/retailList'
        } else if (moduleType === 'PACKAGES') {
          homeUrl = '/packageTicketList'
        }
      }
      this.homeUrl = homeUrl
      this.moduleType = moduleType
    },
    selectLanguage (index) {
      this.language.obj.forEach(item => {
        item.select = false
      })
      this.language.select = this.language.obj[index].text
      this.language.obj[index].select = true
    },
    toPath (path) {
      this.$router.push(path)
    },
    toRegist (i) {
      this.$emit('registShowEvent', i)
    },
    handleLogin () {
      if (sessionStorage.getItem('token')) {
        sessionStorage.removeItem('token')
      }
      this.$emit('handleLogin')
    },
    handleLogOut () {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('loginState')
      this.LoginBtnShow = false
      this.$emit('loginOut')
    },
    handleSelect (index) {
      if (!this.LoginBtnShow && index !== '1') {
        this.$emit('handleLogin')
        return
      }
      sessionStorage.setItem('pageIndex', index)
      if (index === '2') {
        this.$router.push({ path: 'personalCenter', query: { moduleType: this.moduleType } })
        return
      }
      if (index === '3') {
        this.$router.push({ path: 'cart' })
        return
      }
      this.$router.push(this.homeUrl)
    }
  }
}
</script>

<style scoped lang="scss">
.bgwhite {
  background-color: #fff !important;
}
.bgred {
  background-color: #9B232A !important;
}
.trip-logo {
  width: 160px;
  height: 166px;
  background: #9B232A;
  position: absolute;
  left: 90px;
  img {
    width: 138px;
  }
}
.nav {
  background-color: #9B232A;
  position: relative;
  height: 80px;
  line-height: 80px;
  z-index: 2;
  .bg {
    height: 80px;
    opacity: 0.2;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.nav .main_box {
  position: relative;
  z-index: 9;
  height: 80px;
  .logo-red {
    position: absolute;
    top: 15px;
    width: 79px;
    height: 47px;
  }
  .el-menu-trip {
    margin-left: 120px;
    float: left;
    span{
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 24px;
      color: #9B232A;
      margin-right: 36px;
      padding-right: 36px;
      cursor: pointer;
      border-right: 1px solid #9B232A;
    }
    .c-w {
      color: #fff;
      border-right: 1px solid #fff;
    }
    span:last-child {
      border-right: none;
    }
    .active {
      font-weight: bold;
    }
    .cart {
      img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        transform: translateY(5px);
      }
    }
  }
  .el-menu {
    float: left;
    margin-left: 394px;
    background: none;
    border: none;
    height: 80px;
    li {
      color: #FFFFFF;
      opacity: 0.6;
      height: 80px;
      line-height: 80px;
      background: none;
    }
    .el-menu-item {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    img {
      margin-right: 8px;
      transform: translateY(-3px);
    }
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    color: white;
    opacity: 1;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }
}
.nav .logo {
  height: 52px;
  position: absolute;
  top: 50%;
  margin-top: -26px;
}
.nav .logo-text {
  left: 100px;
  img {
    height: 33px !important;
  }
}
.nav .logo img {
  width: 100%;
  height: 50px;
}
.nav .welcome {
  font-size: 14px;
  color: #fff;
  padding-left: 15px;
  position: absolute;
  left: 120px;
}

.nav .order_btn {
  float: right;
  width: 155px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  background-color: #ffb000;
  text-align: center;
  cursor: pointer;
}

.nav .order_btn:hover {
  background-color: #faab00;
}

.nav .order_btn .ico {
  display: inline-block;
  vertical-align: top;
  width: 15px;
  height: 22px;
  margin-top: 14px;
  margin-right: 5px;
  background-image: url(../assets/images/mobile.png);
}

.nav .home_btn {
  z-index: 2000;
  // position: absolute;
  float: right;
  padding-left: 52px;

  box-sizing: border-box;
  text-align: center;
  margin-right: 12px;
  .player_icon {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    border-radius: 50%;
    height: 48px;
  }
  .name-box1 {
    color: #9B232A !important;
    &:hover {
      background: #9B232A !important;
      color: #fff !important;
    }
    .hidden-btn {
      span {
        background: #9B232A !important;
      }
    }
  }
  .name-box {
    position: relative;
    // left: 50px;
    display: inline-block;
    padding: 0 15px;
    height: 36px;
    line-height: 36px;
    // background: #241008;
    color: #FFFFFF;
    font-size: 16px;
    border-radius: 6px;
    cursor: pointer;
    .hidden-mobile {
      display: inline-block;
    }
    &:hover {
      background: #241008;
      .hidden-btn {
        display: block;
      }
      i {
        transform: rotateX(180deg);
      }
    }
    span {
      display: inline-block;
      vertical-align: middle;
      font-size: 16px;
    }
    .icon1 {
      display: inline-block;
      width: 20px;
      height: 22px;
      vertical-align: middle;
      margin: 0 6px 0 16px;
    }
    .icon2 {
      display: inline-block;
      width: 9px;
      height: 5px;
      vertical-align: middle;
    }
  }
  .language {
    .disable {
      pointer-events: none;
    }
    .select {
      color: #FFFFFF;
    }
    .noselect {
      color: #FFFFFF;
      opacity: 0.5;
    }
  }
  .hidden-btn {
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    text-align: center;
    padding-top: 4px;
    display: none;
    span {
      position: relative;
      height: 36px;
      font-size: 16px;
      color: #FFF;
      background: #241008;
      border-bottom: 1px solid;
      line-height: 36px;
      z-index: 100;
      display: block;
      width: 100%;
      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 20px;
      }
    }
  }
}

.nav .home_btn .ico {
  display: inline-block;
  vertical-align: top;
  margin-top: 6px;
  margin-right: 3px;
  width: 20px;
  height: 20px;
  background-image: url(../assets/images/home.png);
}

.banner {
  position: relative;
  z-index: 1;
  width: 100%;
  min-width: 1200px;
  height: 483px;
  overflow: hidden;
}
.el-carousel.el-carousel--horizontal {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.banner-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.btns {
  float: right;
  display: flex;
  align-items: center;
  height: 100%;
  div {
    width: 68px;
    height: 27px;
    line-height: 27px;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
}
.white-btn {
  background-color: #fff;
  border: 1px solid #9B232A;
  color: #9B232A;
}
.red-btn {
  background-color: #9B232A;
  border: 1px solid #FFFFFF;
  color: #FFFFFF;
}
.weChat-box {
  display: inline-block;
  vertical-align: middle;
  line-height: 0;
}
.weChat-box img {
  display: inline-block;
  width: 27px;
  height: 22px;
}
.weChat-box span {
  display: inline-block;
  width: 100%;
  height: 18px;
  font-size: 14px;
  margin-top: 8px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 18px;
  color: #241008;
}
</style>
